import styled from "styled-components";
import CloseIcon from "@mui/icons-material/Close";
import { ASSETS } from "../../utils/config";
import { Typography } from "@mui/material";

export const Wrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 65vw;
  min-width: 600px;
  min-height: 500px;
  height: 60vh;
  background-color: "background.paper";
  box-shadow: 24;
  border-radius: 20px;
  background-image: url(${ASSETS.bg});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  padding: 6vh;
`;

export const Close = styled(CloseIcon)`
  height: 20px;
  width: 20px;
  position: absolute;
  right: 6vh;
  cursor: pointer;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const TitleWrapper = styled.div``;

export const FilterIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  background-color: #f6f7f9;
  border-radius: 5px;
  cursor: pointer;
`;

export const FilterIcon = styled.img``;

export const Row = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

export const Image = styled.img`
  height: 38px;
  width: 39px;
  margin-right: 5px;
`;

export const Heading = styled(Typography)`
  font-family: "DM Sans";
  font-weight: 600;
  font-size: 24px;
  color: #123051;
  margin-left: 8px;
`;

export const Title = styled(Typography)`
  font-family: "DM Sans";
  font-weight: 600;
  font-size: 16px;
  color: #123051;
  margin-bottom: 3px;
  margin-left: 8px;
`;

export const SubTitle = styled(Typography)`
  font-family: "DM Sans";
  font-weight: 400;
  font-size: 10px;
  color: #565556;
  margin-bottom: 3px;
  margin-left: 8px;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 28vh;
  min-height: 250px;
  margin-bottom: 20px;
  margin-top: 10px;
  justify-content: space-between;
`;

export const FilesWrapper = styled.div`
  font-family: "DM Sans";
  font-size: 10px;
  display: flex;
  width: 22%;
  border-color: ${({ isActive }) => (isActive ? "green" : "#e1e1e1")};
  border-width: 1px;
  border-style: dashed;
  border-radius: 15px;
  padding: 10px;
  padding-right: 0;
  margin-right: 15px;
  background-color: ${({ files }) => (files.length ? "white" : "#F6F7F9")};
`;

export const Files = styled.div`
  overflow: scroll;
  height: 100%;
  width: 100%;
`;

export const File = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: #f6f7f9;
  padding: 5px;
  padding-top: 3px;
  padding-bottom: 3px;
  border-radius: 20px;
  border: 1px solid #bbbbbb;
  margin-bottom: 5px;
  overflow: hidden;
`;

export const FileContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 90%;
`;

export const FileIcon = styled.img`
  width: 15px;
  height: 15px;
  margin-right: 5px;
`;

export const FileName = styled(Typography)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 10px;
`;

export const AttachTextWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export const AttachText = styled(Typography)`
  font-family: "DM Sans";
  font-weight: 400;
  font-size: 10px;
  color: #565556;
  margin-bottom: 3px;
  margin-left: 10px;
  margin-right: 10px;
  text-align: center;
`;

export const TextArea = styled.textarea`
  resize: none;
  background-color: white;
  font-family: "DM Sans";
  font-size: 10px;
  border: 1px solid #e1e1e1;
  border-radius: 15px;
  padding: 15px;
  display: flex;
  flex: 3;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const AttachImage = styled.img`
  width: 15px;
  height: 15px;
  margin-bottom: 3px;
  margin-right: 5px;
`;

export const FiltersWrapper = styled.div`
  width: 22%;
  background-color: #f6f7f9;
  border: 1px solid #e1e1e1;
  margin-left: 15px;
  border-radius: 15px;
`;
